import React from "react";
import EADivider from "./EADivider";
import "./SharedStyles.scss";
import { useSelector } from "react-redux";
import { State } from "../../store";

interface IProps {
  title?: string;
  componentId?: string;
}

const EAPageHeader: React.FC<IProps> = ({ title = "", componentId = "" }) => {
  const saleConfiguration = useSelector((state: State) => state.config.configuration);

  const getTitle = () => {
    if (title) {
      return title;
    } else if (saleConfiguration.componentList && componentId) {
      return saleConfiguration.componentList.find((item) => item.id === componentId)?.name;
    } else {
      return "";
    }
  };

  return (
    <div className="page-header">
      <h1>{getTitle()}</h1>
      <EADivider />
    </div>
  );
};

export default EAPageHeader;
